import React from "react";
import { Star, Quote, ShieldCheck, Anchor, Wine, Users2 } from "lucide-react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "./ui/accordion";
import { Reveal, SectionHeading } from "./common";
import { TESTIMONIALS, FAQS, TRUST } from "../data";

/* ---------------- Trust signals bar ---------------- */
export const TrustBar = () => {
  const items = [
    { icon: Star, label: "4.9★ · 687+ five star guest reviews" },
    { icon: Anchor, label: "Departs King Street Wharf, Wharf 3, Sydney Harbour" },
    { icon: Wine, label: "Fully licensed bar on board" },
    { icon: ShieldCheck, label: "Secure booking · Instant confirmation" },
  ];
  return (
    <section data-testid="trust-bar" className="border-y border-white/10 bg-vivid-surface/60 py-8">
      <div className="mx-auto grid max-w-7xl gap-6 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-4">
        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-3">
            <it.icon className="h-6 w-6 shrink-0 text-vivid-magenta" />
            <span className="text-sm text-white/80">{it.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

/* ---------------- Testimonials / reviews ---------------- */
export const Testimonials = () => (
  <section id="reviews" data-testid="reviews-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <SectionHeading
          eyebrow="Customer reviews"
          title="Loved by guests across every Vivid season"
          sub="Real reviews from guests who experienced Vivid Sydney from the water with Vivid Cruises Sydney."
          center
        />
      </Reveal>
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={(i % 3) * 0.08}>
            <div className="h-full rounded-2xl border border-white/10 bg-black/40 p-7">
              <Quote className="h-8 w-8 text-vivid-magenta/60" />
              <div className="mt-3 flex gap-1">
                {[...Array(t.rating)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-vivid-cyan text-vivid-cyan" />
                ))}
              </div>
              <p className="mt-4 text-sm leading-relaxed text-white/80">"{t.text}"</p>
              <p className="mt-5 text-sm font-semibold text-white">{t.name}</p>
              <p className="text-xs text-white/50">{t.location}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

/* ---------------- FAQ ---------------- */
export const FAQSection = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32 bg-vivid-surface/40 border-y border-white/5">
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <Reveal>
        <SectionHeading
          eyebrow="Frequently asked questions"
          title="Everything to know before you book"
          sub="Answers to the most common questions about Vivid Cruises Sydney."
          center
        />
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 w-full space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-white/10 bg-black/30 px-5"
            >
              <AccordionTrigger className="text-left text-base font-medium text-white hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-white/70">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
